import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { getSystemEnv } from '@/utils/env'
import { resolveImageUrl } from '@/utils/constants'
import useIntl from '@/utils/intl'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { useTheme } from '@/context/ThemeContext'
import { useSearchParams } from 'next/navigation'

const DeeplinkPage: React.FC = () => {
  const router = useRouter()
  const { theme } = useTheme()
  const { translate } = useIntl()
  const { key } = router.query
  const searchParams = useSearchParams()
  const [isIOS, setIsIOS] = useState(false)
  const [isHuawei, setIsHuawei] = useState(false)
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    const userAgent = window.navigator.userAgent
    setIsIOS(/iPad|iPhone/.test(userAgent))
    setIsHuawei(userAgent.includes('HUAWEI'))
    setIsAndroid(userAgent.includes('Android'))
    const id = searchParams.get('id')

    if (typeof key === 'string') {
      let deepLinkUrl = ''
      if (id !== undefined && id !== null && id !== '') {
        deepLinkUrl = `mbaopen://mbaopen/${key}/${id}?${searchParams.toString()}`
      } else {
        deepLinkUrl = `mbaopen://mbaopen/${key}?${searchParams.toString()}`
      }
      const timeout = setTimeout(() => {
      }, 1500)

      window.location.href = deepLinkUrl

      setTimeout(() => {
        clearTimeout(timeout)
      }, 2000)
    }
  }, [key])

  const handleDownloadApp = (): void => {
    const appStoreUrl = isIOS
      ? 'https://apps.apple.com/us/app/mobicom/id567384694'
      : isHuawei
        ? 'https://appgallery.huawei.com/#/app/C102649417'
        : isAndroid
          ? 'https://play.google.com/store/apps/details?id=mn.mobicom.onemediastore&hl=en&gl=US'
          : getSystemEnv().DOMAIN

    window.location.href = appStoreUrl
  }

  return (
    <div className='flex md:flex-row-reverse flex-col justify-center items-center gap-8 md:gap-16 p-12'>
      <div className='flex flex-col gap-4 md:w-1/3'>
        <div className='p-1 bg-[#1D252D] rounded-xl w-12 aspect-square flex justify-center items-center'>
          <img draggable={false} width={16} height={16} className='w-full' src={resolveImageUrl('/uploads/mobicom-logo-hq.png')} />
        </div>
        <h1 className='text-textHigh font-extrabold text-2xl lg:text-4xl'>{translate('openApp.title')}</h1>
        <span className='text-textMid'>{translate('simple')}</span>
        <div className='flex gap-4'>
          <DarkButton
            size='sm'
            leadingIconImg={theme === 'dark' ? resolveImageUrl('/uploads/download-white.svg') : resolveImageUrl('/uploads/download-black.svg')}
            type='soft'
            onClick={handleDownloadApp}
          >
            {translate('openApp.download')}
          </DarkButton>
        </div>
      </div>
      <img
        draggable={false}
        width={16}
        height={16}
        className='w-full md:w-1/3'
        src={theme === 'dark' ? resolveImageUrl('/uploads/downloadApp-black.png') : resolveImageUrl('/uploads/downloadApp-white.png')}
      />
    </div>
  )
}

export default DeeplinkPage
